/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import Svg from '../../../../widgets/Svg/Svg';
import ModalDialog from "../../../../widgets/ModalDialog/ModalDialogLink";
import Om3pModal from "../OM3PComponents/Om3pModal";
import {PERMISSIONS} from '../../../../../constants/APP_CONSTANTS';
import UserPermissionSingleton from '../../../../../_helpers/UserPermissionSingleton';

// Previously this extended React.Component
// That was a good thing, because using React.PureComponent can hide
// issues with the selectors. However, moving it over does can considerable
// performance improvements when reordering big lists (400ms => 200ms)
// Need to be super sure we are not relying on PureComponent here for
// things we should be doing in the selector as we do not know if consumers
// will be using PureComponent
export default class TableItems extends React.PureComponent {

    render() {
        const {index, deleteInstance, resourceIn, provided , chapterId, collectionId, length, activeCollection,
            resourceUploadData, updateAdditionalResourceInfo, resourceUploadSuccessDataEdit, getResource, closeModal,
            clearResource, clearAdditionalInfo}   = this.props;

        const createPayload = (data) => {
            const payload = {
                "resourceIds": [data]
            };
            return payload;
        };

        const createNewPart = (sequence, chapterId) => {
            const payload = {
                "chapterId": chapterId,
                "createAfter": sequence
            };
            this.props.freezeUi(true);
            this.props.createPart(collectionId,payload);
        };
        return (
            <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
            >
                <div className={"table-body" + (resourceIn.sharing === "Private" ? ' disable' : '')} >
                    {<div className='index cell' >{index+1}</div>}
                    { resourceIn.sharing === "Private" ? <div className='col-3 cell' >{resourceIn.title} <br></br><span className={"retired"}><b>Retired Content</b></span></div>: <div className='col-3 cell' >
                        {(resourceIn.pearsonResourceType === 'OM' || resourceIn.pearsonResourceType === 'PearsonRights')
                            ? <ModalDialog
                                trigger={<a className="ancorStyle"> {resourceIn.title} </a>}
                                title="Edit Original Material or 3rd Party Material">
                                <Om3pModal activeCollection={activeCollection}
                                    resourceUploadData={resourceUploadData}
                                    updateAdditionalResourceInfo={updateAdditionalResourceInfo}
                                    resourceUploadSuccessDataEdit={resourceUploadSuccessDataEdit}
                                    getResource={getResource}
                                    resourceInfo={resourceIn}
                                    closeModal={closeModal}
                                    editModal={true}
                                    clearResource={clearResource}
                                    clearAdditionalInfo ={clearAdditionalInfo}/>
                            </ModalDialog>: resourceIn.title}
                    </div> }
                    <div className='col-3 cell dots' >{resourceIn.fileName}</div>
                    <div className='col-3-5 cell' >{resourceIn.authors}</div>
                    <div className='col-1-5 cell' >{(resourceIn.publisherName && resourceIn.publisherName !== "Pearson" )? resourceIn.publisherName.split(" ")[0]: ""}</div>
                    <div className='col-2 cell' >{resourceIn.category === "Case" ? resourceIn.category : resourceIn.isbn}</div>
                    <div className='col-1 cell' >{resourceIn.price}</div>
                    {
                        UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_delete_chapter) ?
                            <div className='cell svg' style={{cursor: 'default'}}>
                                <span>
                                    <Svg svgString={'delete-18'} style={{fill: 'lightGrey'}}></Svg>
                                </span>
                            </div>
                            :
                            <div className='cell svg' onClick={(e)=>{deleteInstance(createPayload(resourceIn.resource));}}>
                                <span>
                                    <Svg svgString={'delete-18'}></Svg>
                                </span>
                            </div>
                    }
                </div>
                {  !UserPermissionSingleton.hasPermission(PERMISSIONS.hide_adding_part) && resourceIn.sequence < length-1  && <div className="create-part-option-holder">
                    <div className="button-wrapper">
                        <div className="button-wrapper-child">
                            <button className="create-part-btn" onClick={()=>{createNewPart(resourceIn.sequence, chapterId);}}>+ Part</button>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/ChapterComponents/TableItems.js